// liste des médias
export enum COMPONENTRESOURCES {
  
  // pas de média
  //COMMON_UPLOAD = 'assets/component/icons/nomedia.svg',
  COMMON_UPLOAD = 'assets/component/icons/nomedia2.png',
  // toast
  TOAST_SUCCESS = 'assets/component/icons/icon_success.png',
  TOAST_ERROR = 'assets/component/icons/icon_error.png',
  TOAST_WARNING = 'assets/component/icons/icon_warning.png',

  // modes de lancement
  RUN_MODE_TEST = 'assets/component/icons/test.png',
  RUN_MODE_QUAL = 'assets/component/icons/qual.png',
  RUN_MODE_PROD = 'assets/component/icons/prod.png',

  EXCEL = 'assets/component/icons/excel.png',
  PDF = 'assets/component/icons/pdf.png',
  
}
